import AxiomBarChart from "../../../../AxiomComponents/AxiomBarChart/AxiomBarChart.jsx";
import * as AxiomFormula from "../../../../AxiomComponents/AxiomGrid/component/reference/plugins/commonJS/AxiomFormula.js";

import "./axiomBarChartComponent.css";
const numeral = require("numeral");
const colors = [
  "#f28e2c",
  "#e15759",
  "#76b7b2",
  "#59a14f",
  "#edc949",
  "#af7aa1",
  "#ff9da7",
  "#9c755f",
  "#bab0ab",
  "#4e79a7",
];

function groupedBarChartComponent(
  componentName,
  availableHeight,
  availableWidth,
  data,
  appName,
  appID,
  field,
  value,
  pointInfo,
  extraParams
) {
  const colors = [
    "#f28e2c",
    "#e15759",
    "#76b7b2",
    "#59a14f",
    "#edc949",
    "#af7aa1",
    "#ff9da7",
    "#9c755f",
    "#bab0ab",
    "#4e79a7",
  ];
  const totalPoints = data.length;

  let filterFormula = extraParams.filterExpression;
  if (filterFormula) {
    filterFormula = AxiomFormula.evaluateAxiomFormula({
      formula: filterFormula,
      getSplitValues: true,
    });
  }

  const filteredPoints = data.filter((d) => {
    if (filterFormula) {
      const formulaVariables = [];
      filterFormula.formulaVariables.forEach((f) => {
        formulaVariables.push(d[f]);
      });
      return AxiomFormula.evaluateAxiomFormula({
        formulaTree: filterFormula.formulaTree,
        rangeKeys: [],
        rangeValues: {},
        variableKeys: filterFormula.formulaVariables,
        variableValues: formulaVariables,
      });
    } else {
      return true;
    }
  }).length;
  const title = [
    { text: `For ${filteredPoints} out of ${totalPoints}`, class: "highlight" },
    { text: `${extraParams.distributionBy}, ${extraParams.filterText} for ${field}` },
    { text: value, class: "highlight" },
  ];
  const columnData = [extraParams.distributionBy, ...extraParams.groups].map((d, i) => {
    return {
      col: d,
      displayName: d,
      tooltipDisplayName: d,
      style: {
        width: availableWidth / (extraParams.groups.length + 1),
      },
      sorting: "",
    };
  });

  const overallMax = d3.max(
    extraParams.groups.map((g) => {
      return d3.max(
        data.map((d) => {
          return +d[g];
        })
      );
    })
  );

  const tableData = data
    .sort((a, b) => {
      return +b[extraParams.groups[0]] - +a[extraParams.groups[0]];
    })
    .map((d, di) => {
      const tableRow = {};
      tableRow[extraParams.distributionBy] = { text: d[extraParams.distributionBy] };
      extraParams.groups.forEach((g, gi) => {
        tableRow[g] = {
          text: numeral(+d[g]).format("0,0.[0]"),
          number: (+d[g] * 100) / overallMax,
          background: colors[gi % colors.length],
          height: 22,
        };
      });
      return tableRow;
      // return {
      //   Rank: { text: d.srNo },
      //   Combination: { text: `${nodesData[d.source].label} - ${nodesData[d.target].label}` },
      //   "%": { text: `${numeral(d["subcat2_vol_with_1"] / d["subcat2_vol"]).format("0.0%")}` },
      //   S: { text: `${numeral(d["support"]).format("0.00")}`, background: "#EBEBEB", number: 100, height: 23 },
      //   C: { text: `${numeral(d["confidence"]).format("0.00")}`, background: "#DCEDF2", number: 100, height: 23 },
      //   L: { text: `${numeral(d["lift"]).format("0.00")}`, background: "#F3E0E5", number: 100, height: 23 }
      // };
    });

  const component = (
    <AxiomBarChart
      appName={appName}
      appID={appID}
      componentID="0"
      id={AxiomAPIs.generateUUID(16, "aA")}
      selectedCol={"dimension"}
      height={availableHeight}
      barChartData={tableData}
      columnData={columnData}
      rowHeight={"30px"}
      stickySummary={true}
      addToDrillDown={() => {}}
      tooltipShow={true}
    />
  );
  return { title, component };
}

module.exports = groupedBarChartComponent;
